import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=2633ac2b&scoped=true"
import script from "./Comments.vue?vue&type=script&lang=ts"
export * from "./Comments.vue?vue&type=script&lang=ts"
import style0 from "./Comments.vue?vue&type=style&index=0&id=2633ac2b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2633ac2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2633ac2b')) {
      api.createRecord('2633ac2b', component.options)
    } else {
      api.reload('2633ac2b', component.options)
    }
    module.hot.accept("./Comments.vue?vue&type=template&id=2633ac2b&scoped=true", function () {
      api.rerender('2633ac2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/comment-edit/Comments.vue"
export default component.exports